var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"local-tenant display-flex width-percent-100 height-percent-100"},[_vm._m(0),_c('div',{staticClass:"right bc-white br-4 display-flex ai-center jc-center"},[_c('el-empty',{attrs:{"description":"功能开发中"}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left bc-white br-4 padding-20"},[_c('div',{staticClass:"mb-20"},[_c('b',{staticClass:"fs-18"},[_vm._v("本地化租户")])])])
}]

export { render, staticRenderFns }